// These are the sticker dot colors specified in the Figma design
export const DOT_COLOR = {
  orange: '#F68C2C', // Cheese Puff
  purple: '#8D83BE', // Dusk
  green: '#00B0AC', // Kiddie Pool
  blue: '#0075C9', // Clayton Blue
};

// The sticker type numbers were copied from retail project and should correspond to the database values.
// Some are commented out because we are not using them at this time, but I wanted to make a note of them.
export const STICKER_TYPES = {
  '-7': { label: 'IN STOCK', dotColor: DOT_COLOR.green },
  '-6': { label: 'COMING SOON', dotColor: DOT_COLOR.purple },
  // '-5': { label: 'CROSSMOD ELIGIBLE', dotColor: '' },
  // '-4': { label: 'CROSSMOD', dotColor: '' },
  // '-3': { label: 'SALE', dotColor: '' },
  '-2': { label: 'NEW ARRIVAL', dotColor: DOT_COLOR.blue },
  '-1': { label: 'SOLD', dotColor: DOT_COLOR.orange },
  1: { label: 'MOVE-IN READY', dotColor: DOT_COLOR.blue },
  2: { label: 'UPGRADES INCLUDED', dotColor: DOT_COLOR.blue },
  3: { label: 'GREAT VALUE', dotColor: DOT_COLOR.blue },
  4: { label: 'QUICK DELIVERY', dotColor: DOT_COLOR.blue },
  5: { label: 'SALE PENDING', dotColor: DOT_COLOR.orange },
  // 6: { label: 'PRICE DROP', dotColor: '' },
};
